import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import axios from 'helpers/api';
import * as mapYourMedsConstant from '../../../common/mapYourMedsConstant.js';

const DrugUnitForm = (props) => {
    const initialFormData = {
        unit: "",
        isactive: true,
        id: ""
    };

    const [formData, setFormData] = useState(initialFormData);
    const formRef = useRef(null);
    const [buttonStatus, setButtonStatus] = useState(mapYourMedsConstant.ADD_ACTION);

    useEffect(() => {
        const val = props.drugunitvalue || props.medhrvalue;
        if (val && (val.unit_id || val.drug_unit_id || val.hour_id || val.id)) {
            const { unit, unit_name, hour, hrtime, is_active, unit_id, drug_unit_id, hour_id, id } = val;
            setFormData({
                unit: unit || unit_name || hour || hrtime || "",
                isactive: is_active == 1 || is_active === '1' || is_active === true,
                id: unit_id || drug_unit_id || hour_id || id || ""
            });
            setButtonStatus(mapYourMedsConstant.UPDATE_ACTION);
        } else {
            setFormData(initialFormData);
            setButtonStatus(mapYourMedsConstant.ADD_ACTION);
        }
    }, [props.edittrigger, props.drugunitvalue, props.medhrvalue]);

    const isAddMode = buttonStatus === "Add" || buttonStatus === mapYourMedsConstant.ADD_ACTION;

    const handleSubmit = async e => {
        e.preventDefault();

        let tokenStr = localStorage.getItem("accessToken");
        let pelmedsDrugUnitUrl = isAddMode ? `${process.env.REACT_APP_SERVER_URL}/drugs/add-drug-unit` : `${process.env.REACT_APP_SERVER_URL}/drugs/update-drug-unit`;
        let pelmedsDrugUnitData = isAddMode ? 
            { "unit": formData.unit, "group_id": localStorage.getItem("groupId") || '', "is_active": 1 } :
            { "unit": formData.unit, "group_id": localStorage.getItem("groupId") || '', "is_active": formData.isactive ? 1 : 0, "id": formData.id };

        const { data } = await axios.post(pelmedsDrugUnitUrl, pelmedsDrugUnitData, { headers: { 'Authorization': `Bearer ${tokenStr}` } });

        if (data.status) {
            toast.success(isAddMode ? "Drug Unit added successfully" : "Drug Unit updated successfully");
        }
        else {
            toast.info("Error while adding/updating Drug Unit");
        }

        setFormData(initialFormData);
        formRef.current.reset();
        setButtonStatus("Add");

        if (props.onCallParent) {
            props.onCallParent();
        }
    };

    const handleFieldChange = e => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    return (
        <Form ref={formRef} onSubmit={handleSubmit}>
            <Row>
                <Col xs={6}>
                    <Form.Group className="mb-3">
                        <Form.Label className="required">Drug Unit</Form.Label>
                        <Form.Control
                            placeholder='Drug Unit'
                            value={formData.unit}
                            name="unit"
                            onChange={handleFieldChange}
                            size="sm"
                            type="text"
                        />
                    </Form.Group>
                </Col>
                <Col xs={6}>
                    <Form.Group>
                        <Button
                            type="submit"
                            color="primary"
                            className="mt-4 w-50"
                            size="sm"
                            disabled={!formData.unit}>
                            {buttonStatus}
                        </Button>
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col xs={12}>
                    <Form.Group>
                        <Form.Check
                            type='switch'
                            name="isactive"
                            id='isactive'
                            checked={isAddMode ? true : formData.isactive}
                            disabled={isAddMode}
                            onChange={e =>
                                setFormData({
                                    ...formData,
                                    isactive: e.target.checked
                                })
                            }
                            label='Active'
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Form.Label><span className="text-danger">*</span> indicates required field</Form.Label>
                </Col>
            </Row>
        </Form>
    );
};

DrugUnitForm.propTypes = {
    drugunitvalue: PropTypes.any,
    medhrvalue: PropTypes.any,
    edittrigger: PropTypes.number,
    onCallParent: PropTypes.func
};

export default DrugUnitForm;
